export const getRoomName = (user) => user && (
  (user.class && user.class.name) || (user.nurseryClass && user.nurseryClass.name)
)
